import { Route, Routes } from "react-router-dom";
import AppsError from "./apps-error";
import { CartProvider } from "../context/cart";
import { BorseProvider } from "../context/borse";
import { CheckUpProvider } from "../context/check-up";
import { OsteopataProvider } from "../context/osteopata";
import CarrelloDellaSpesa from "./carrello-della-spesa";
import BorseDiStudio from "./borse-di-studio";
import CheckUpSanitario from "./check-up-sanitario";
import OsteopataRoute from "./osteopata-route";

const routes = [
  {
    id: "cart",
    path: "/carrello-della-spesa",
    element: (
      <CartProvider>
        <CarrelloDellaSpesa />
      </CartProvider>
    ),
    visibility: true,
  },
  {
    id: "scholarships",
    path: "/borse-di-studio",
    element: (
      <BorseProvider>
        <BorseDiStudio />
      </BorseProvider>
    ),
    visibility: true,
  },
  {
    id: "check-up",
    path: "/check-up-sanitario",
    element: (
      <CheckUpProvider>
        <CheckUpSanitario />
      </CheckUpProvider>
    ),
    visibility: true,
  },
  {
    id: "osteopath",
    path: "/osteopata",
    element: (
      <OsteopataProvider>
        <OsteopataRoute />
      </OsteopataProvider>
    ),
    visibility: true,
  },
];

const WelfareRouter = () => {
  return (
    <Routes>
      {routes
        ?.filter(({ visibility }) => visibility)
        ?.map(({ path, element, id }) => (
          <Route key={id} path={path} element={element} />
        ))}
      <Route path="*" element={<AppsError />} />
    </Routes>
  );
};

export default WelfareRouter;
